import React, {useState, useEffect, useContext} from "react";
import {useSelector} from "react-redux/es/exports";
import {useParams} from "react-router-dom";
import {getTextureById} from "../../services/textureService";
import {useNavigate} from "react-router-dom";
import FormTemplate from "../../components/templates/FormTemplate";

const AddChildTemplate = () => {
    const [data, setData] = useState([]);
    const {token} = useSelector((state) => state.user);
    const {parentId} = useParams();
    const {id} = useParams();
    const navigate = useNavigate();

    const fetchDataById = async () => {
        const response = await getTextureById(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/templates/${id}`,
            token
        );
        if (response.success) {
            console.log('response.data', response.data);
            setData(response.data);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (id) {
            fetchDataById();
        } else {
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <FormTemplate data={data} id={id} parentId={parentId}/>
        </>
    );
};

export default AddChildTemplate;
